export default function removeTrailingSpaces(label: string) {
  return label.trim();
}
